import classNames from './styles.module.scss'


export default function SpacingField(props) {
  return (
    <div {...props} className={classNames.spacingField} />
  )
}
